// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".padded-message[data-v-078e8cd9]{padding:50px;padding-top:35px;text-align:center}", ""]);
// Exports
module.exports = exports;
